import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["type", "value"]

import { ref, Ref } from 'vue';
import { UPDATE_MODEL_EVENT } from '@/core/consts';

import { NkButton } from '@/core/components';

import { props as propsDefinition } from './input-number.shared';
import {StInputNumber} from './input-number.styled';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkInputNumber',
  props: propsDefinition,
  emits: [UPDATE_MODEL_EVENT],
  setup(__props, { emit }) {

const props = __props




const input: Ref<HTMLInputElement|null> = ref(null);

const handleInputChange = () => {
  // Transforme la valeur à virgule en valeur à point si float
  if (input.value?.value && props.float) {
    input.value.value = input.value.value.replace(',', '.');
  }

  if (Number(input.value?.value) > props.max) {
    (input.value as HTMLInputElement).value = props.max.toString();
    return emit(UPDATE_MODEL_EVENT, props.max);
  }

  if (Number(input.value?.value) < props.min) {
    (input.value as HTMLInputElement).value = props.min.toString();
    return emit(UPDATE_MODEL_EVENT, props.min);
  }

  return emit(UPDATE_MODEL_EVENT, Number(input.value?.value));
}

const increaseValue = () => {
  const preValue = props.modelValue + props.step;

  if (preValue <=props.max) {
    emit(UPDATE_MODEL_EVENT, preValue);
  }
};

const decreaseValue = () => {
  const preValue = props.modelValue - props.step;

  if (preValue >= props.min) {
    emit(UPDATE_MODEL_EVENT, preValue);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StInputNumber), _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
    default: _withCtx(() => [
      _createVNode(_unref(NkButton), {
        icon: "NkMinus",
        onClick: _withModifiers(decreaseValue, ["prevent"])
      }, null, 8, ["onClick"]),
      _createElementVNode("input", {
        ref_key: "input",
        ref: input,
        type: props.float ? 'text' : 'number',
        value: props.modelValue,
        onChange: handleInputChange
      }, null, 40, _hoisted_1),
      _createVNode(_unref(NkButton), {
        icon: "NkPlus",
        onClick: _withModifiers(increaseValue, ["prevent"])
      }, null, 8, ["onClick"])
    ]),
    _: 1
  }, 16))
}
}

})